import { MetaTags, ZeroStatePage } from '@devd-client/devd/components';
import { useQualityPage } from '../../api';
import QualityPage from './devd-quality';

export const Quality = () => {
  const { data } = useQualityPage();
  return (
    <>
      <MetaTags title="Quality | Metrics | Devdynamics" />
      {data && data?.dto?.enabled ? (
        <QualityPage metricsData={data} />
      ) : (
        <ZeroStatePage
          data={data?.dto}
          featureAlert={data?.featureEnable === false ? true : false}
        />
      )}
    </>
  );
};

export default Quality;
